import React, { useState } from "react";
import SidebarField from "../../../Components/SidebarField";

const DeliverymanDetails = ({ data,modal,setModal }) => {
  const [activeTab, setActiveTab] = useState("details");

  console.log("data",data);
  
  const tabs = [
    { id: "details", label: "Details" },
    { id: "documents", label: "Documents" },
    { id: "vehicle", label: "Vehicle" },
    { id: "review", label: "Review" },
    { id: "order", label: "Order Information" },
  ];

  if (modal) {   
      return (
       
         <SidebarField
         footer={false}
         handleClose={() => setModal(false)}
         title={`Order Details`}
         padding='p-0'
       >
          <div className="bg-transparent w-full">
          {/* <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-semibold">{data?.name}</h1>
            <span
              className={`px-3 py-1 text-sm rounded ${
                data?.approvalStatus === "Approved"
                  ? "bg-green-100 text-green-800"
                  : "bg-yellow-100 text-yellow-800"
              }`}
            >
              {data?.approvalStatus}
            </span>
          </div> */}
    
          <div className="px-4 pt-2 flex space-x-4 border-b">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`pb-2 ${
                  activeTab === tab.id
                    ? "border-b-2 border-[--color--11] text-[--color--11]"
                    : ""
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
    
          <div className="mt-4 p-4">
            {activeTab === "details" && (
              <div>
                {/* Basic Information */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">Basic Information</h2>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-medium">Name</label>
                      <span>{`${data?.firstName}  ${data?.lastName}`}</span>
                    </div>
                    <div>
                      <label className="text-sm font-medium">Phone</label>
                      <p>{data?.phone}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium">Email</label>
                      <p>{data?.email}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium">Address</label>
                      <p>{data?.address || "Not Provided"}</p>
                    </div>
                  </div>
                </section>
    
                {/* Current Status */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">Current Status</h2>
                  <p>Status: {data?.currentStatus?.status}</p>
                  <p>Last Updated: {new Date(data?.currentStatus?.lastUpdate).toLocaleDateString()}</p>
                </section>
    
                {/* Statistics */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">Statistics</h2>
                  <p>Total Deliveries: {data?.statistics?.totalDeliveries}</p>
                  <p>Total Distance: {data?.statistics?.totalDistance} km</p>
                  <p>Completion Rate: {data?.statistics?.completionRate}%</p>
                  <p>Cancelled Deliveries: {data?.statistics?.cancelledDeliveries}</p>
                </section>
    
                {/* Bank Details */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">Bank Details</h2>
                  <p>Account Holder: {data?.bankDetails?.accountHolder}</p>
                  <p>Account Number: {data?.bankDetails?.accountNumber}</p>
                  <p>Bank Name: {data?.bankDetails?.bankName}</p>
                  <p>IFSC Code: {data?.bankDetails?.ifscCode}</p>
                </section>
              </div>
            )}
    
            {activeTab === "documents" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">Documents</h2>
                {Object.entries(data?.documents).map(([key, doc]) => (
                  <div key={key} className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                    <p>
                      <strong>{key}</strong>: {doc?.number || "Not Provided"}{" "}
                      {doc?.verified ? "(Verified)" : "(Not Verified)"}
                    </p>
                    <p>Expiry: {new Date(doc?.expiryDate).toLocaleDateString()}</p>
                  </div>
                ))}
              </div>
            )}
    
            {activeTab === "vehicle" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">Registered Vehicles</h2>
                  <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                    {data?.vehicleDetails?.model} - {data?.vehicleDetails?.registrationNumber} ({data?.vehicleDetails?.year})
                  </p>
              </div>
            )}
    
            {activeTab === "review" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">Reviews & Ratings</h2>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">Average Rating: {data?.reviews?.average} / 5</p>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">Total Reviews: {data?.reviews?.count}</p>
              </div>
            )}
    
            {activeTab === "order" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">Order Information</h2>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">No orders available.</p>
              </div>
            )}
          </div>
        </div>
       </SidebarField>
      );
  }
};

export default DeliverymanDetails;
